import { render, staticRenderFns } from "./Tip.vue?vue&type=template&id=72c554ac&scoped=true"
import script from "./Tip.vue?vue&type=script&lang=ts"
export * from "./Tip.vue?vue&type=script&lang=ts"
import style0 from "./Tip.vue?vue&type=style&index=0&id=72c554ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c554ac",
  null
  
)

export default component.exports